import { Pipe, PipeTransform } from '@angular/core';
import { HhsgSharedClientApplication } from '../../../models/client-application.model';
import { HhsgSharedClientContactApplication } from '../../../models/client-contact.model';

@Pipe({
    name: 'contactHasAppFilter',
    pure: false
})
export class ContactHasAppFilter implements PipeTransform {
    transform(clientApplications: HhsgSharedClientApplication[], activeApplications: HhsgSharedClientContactApplication[]): HhsgSharedClientApplication[] {
        if (!clientApplications || !activeApplications) { return []; }

        return clientApplications.filter( app => {
            return activeApplications.find(activeApp => app.applicationId === activeApp.applicationId);
        });
    }
}
